import { Link, useParams } from 'react-router'
import Table from '../Components/AdminTable.js'
import React, { useEffect, useState } from 'react'
import { call } from '../Methods.js'
import FormModal from '../Components/FormModal.js'

function Courses () {
  const pageName = 'courses'
  const pageTitle = 'Kurslar / Təlimlər'
  document.title = `${pageTitle} | ${process.env.REACT_APP_NAME}`
  const [updateTable, setUpdateTable] = useState(false)

  useEffect(() => {
    if (updateTable) {
      setUpdateTable(false)
    }
  }, [updateTable])

  const tableSettings = {
    name: '',
    label: '',
    filters: true,
    pagination: true,
    actions: {
      get: async (params = {}) => {
        const courses = await call.forLoggedUser.course.getCourses(params)
        if (courses.success) {
          return courses.data
        }
        return []
      }
    },
    columns: [
      {
        title: '#',
        property: 'rowNumber',
        style: { width: '30px' },
        filter: {
          enabled: false
        }
      },
      {
        title: 'Adı',
        property: ['name', 'code'],
        style: { width: '50%' },
        filter: {
          enabled: true,
          type: 'text',
          name: 'name'
        },
        mutate: values => {
          return `${values[0]} (${values[1]})`
        }
      },
      {
        title: 'Qruplar',
        property: 'activeGroups',
        style: { width: '10%' },
        filter: {
          enabled: false,
          type: 'number',
          name: 'activeGroups'
        }
      },
      {
        title: 'İştirakçılar',
        property: 'activeStudents',
        style: { width: '10%' },
        filter: {
          enabled: false,
          type: 'text',
          name: 'activeStudents'
        }
      },
      {
        title: 'Ödəniş',
        property: 'monthlyPrice',
        type:'number',
        style: { width: '10%' },
        filter: {
          enabled: true,
          type: 'number',
          name: 'monthlyPrice'
        },
        mutate: value => {
          if (value != null) {
            return `${value} ₼`
                
          }
        }
      },
      {
        title: 'Status',
        property: 'statusName',
        type:'status-label',
        style: { width: '10%' },
        filter: {
          enabled: true,
          type: 'select',
          name: 'statusId',
          dataSource: async () => {
            const source = await call.forLoggedUser.status.getStatuses({
              type: 'course'
            })
            let data = source.data.map(d => {
              return { value: d.id, text: d.description }
            })
            return data
          }
        },
        mutate: value => {
          return value
        }
      },
      {
        title: 'Əməliyyat',
        property: ['id'],
        type: 'actions-list',
        operations:(values)=>[
          {
            type:'link',
            name:'Edit',
            title:'Düzəliş',
            link:`${values[0]}`,
            iconType:'path',
            icon:'/Images/Icons/edit.png',
            disablingConditions:[],
          },
        ],
        style: {width:'10%',minWidth: '50px'}
      }
    ],
    addNew: {
      enabled: true,
      url: `/${pageName}/add`,
      title: '+ Əlavə et'
    }
  }

  const formSettings = [
    {
      name: 'course',
      id: '',
      label: 'Təlim',
      isMain: true,
      actions: {
        get: id => call.forLoggedUser.course.getCourseById({ id: id }),
        add: call.forLoggedUser.course.addCourse,
        edit: call.forLoggedUser.course.updateCourse
      },
      formLists: {
        Statuses: async () => {
          const source = await call.forLoggedUser.status.getStatuses({
            type: 'course'
          })
          let data = source.data.map(d => {
            return { value: d.id, text: d.description }
          })
          return data
        }
      },
      fields: [
        { type: 'hidden', fieldName: 'id', label: '' },
        {
          type: 'text',
          fieldName: 'name',
          label: 'Adı',
          col: { sm: 6 },
          validationRules: ['required']
        },
        { type: 'text', fieldName: 'code', label: 'Kod', col: { sm: 3 },validationRules: ['required'] },
        {
          type: 'number',
          fieldName: 'monthlyPrice',
          label: 'Aylıq ödəniş',
          defaultValue: 0,
          col: { sm: 3 }
        },
        {
          type: 'input-group-section',
          fieldName: 'approximate',
          label: 'Təxmini dəyərlər',
          fields: [
            {
              type: 'number',
              fieldName: 'months',
              label: 'Müddət (ay)',
              col: { sm: 3 }
            },
            {
              type: 'number',
              fieldName: 'classesPerWeek',
              label: 'Dərs sayı/həftə',
              col: { sm: 3 }
            },
            {
              type: 'number',
              fieldName: 'durationPerClass',
              label: 'Dərs müddəti (saat)',
              col: { sm: 3 }
            },
            {
              type: 'number',
              fieldName: 'totalClasses',
              label: 'Cəmi dərs sayı',
              col: { sm: 3 }
            }
          ]
        },
        {
          type: 'text',
          fieldName: 'description',
          label: 'Açıqlama',
          col: { sm: 12 }
        },
        {
          type: 'select',
          fieldName: 'statusId',
          label: 'Status',
          defaultValue: 0,
          col: { sm: 6 },
          data: 'Statuses'
        },
        { type: 'submit', label: 'Təsdiq', col: { sm: 12 } }
      ]
    },
    {
      name: 'prices',
      id: '',
      label: 'Qiymətlər',
      isStandAlone: false,
      isMain: false,
      actions: {
        get: id => call.forLoggedUser.course.getPriceList({ courseId: id }),
        edit: call.forLoggedUser.course.editPriceList
      },
      formLists: {
        Statuses: async () => {
          const source = await call.forLoggedUser.status.getStatuses({
            type: 'price'
          })
          let data = source.data.map(d => {
            return { value: d.id, text: d.description }
          })
          return data
        }
      },
      fields: [
        { type: 'hidden', fieldName: 'courseId', label: '' },
        {
          label: 'Təlim / Kurs',
          type: 'readonly-text',
          fieldName: 'courseName',
          col: { sm: 12 }
        },
        {
          label: 'Qiymətlər',
          type: 'input-group-row',
          fieldName: 'prices',
          defaultValue: [],
          addRowPermission: false,
          multipleRows: true,
          removeRowPermission: false,
          rowStyleRules: [
            {
              fieldName: 'statusId',
              getStyleRule: value => {
                if (value == 1) return { backgroundColor: '#02c8685c' }
                if (value == 0) return { backgroundColor: '#fff1b666' }
              }
            }
          ],
          col: { sm: 12 },
          rowFields: [
            {
              label: '',
              type: 'hidden',
              fieldName: 'id',
              col: { sm: 0 }
            },
            {
              label: '',
              type: 'hidden',
              fieldName: 'courseId',
              col: { sm: 0 }
            },
            {
              label: 'Başlanğıc tarixi',
              type: 'date',
              fieldName: 'fromDate',
              disabled: true,
              mutate: value => {
                return ![undefined, null, ''].includes(value)
                  ? new Date(value).toLocaleDateString('az-AZ')
                  : ''
              }
            },
            {
              label: 'Bitmə tarixi',
              type: 'date',
              fieldName: 'toDate',
              disabled: true,
              mutate: value => {
                return ![undefined, null, ''].includes(value)
                  ? new Date(value).toLocaleDateString('az-AZ')
                  : ''
              }
            },
            {
              type: 'number',
              fieldName: 'monthlyPrice',
              disabled: true,
              label: 'Qiymət',
              validationRules: ['required']
            },
            {
              type: 'text',
              fieldName: 'description',
              label: 'Açıqlama',
              col: { sm: 12 }
            },
            {
              type: 'select',
              fieldName: 'statusId',
              label: 'Status',
              defaultValue: 0,
              disabled: true,
              col: { sm: 6 },
              data: 'Statuses'
            }
          ]
        },
        { type: 'submit', label: 'Təsdiq', col: { sm: 12 } }
      ]
    }
  ]

  return (
    <div className='page'>
      <h1 className='page-title'>{pageTitle}</h1>
      <Table tableSettings={tableSettings} updateTable={updateTable} />

      <FormModal
        moduleUrl={`/${pageName}`}
        formSettings={formSettings}
        onSubmit={() => setUpdateTable(true)}
      />
    </div>
  )
}

export default Courses
